var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-page',{attrs:{"id":"main"},on:{"show":_vm.onShow}},[_c('v-ons-tabbar',{attrs:{"position":"bottom","tabs":_vm.mainTabs,"index":_vm.index},on:{"update:index":function($event){_vm.index=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }